import React from "react";
import { useNavigate } from "react-router-dom";
import "./GameCard.css";
import { buildGamePath } from "../../utils/appRoutes";
import { formatDayFirstDate } from "../../utils/dateFormatting";

export const GameCard = ({ 
  imageSrc, 
  gameName, 
  gameSubtitle, 
  gameDay, 
  gameTime, 
  score,
  gameId, 
  className, 
  style = {} 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!gameId) return;
    navigate(buildGamePath(gameId));
  };

  // Helper function to format the day and time
  const formatGameDateTime = (dayString, timeString) => {
    if (!dayString) {
      return "Date not available";
    }

    const date = new Date(dayString);
    if (isNaN(date)) {
      return "Invalid Date";
    }

    if (!timeString) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }

    // Format the day (e.g., "Mon")
    const dayOfWeek = formatDayFirstDate(date, { weekday: "short" });
    const dateFormatted = formatDayFirstDate(date, {
      day: "2-digit",
      month: "2-digit",
    });

    // Format the time in 24-hour format
    const timeFormatted = new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${dayOfWeek}, ${dateFormatted} at ${timeFormatted}`;
  };

  return (
    <div 
      className={`game-card-container ${score ? "has-score" : ""} ${className}`} 
      onClick={handleClick} 
      style={style}
    >
      <div className="game-card">
        <div className="image-wrapper">
          <img 
            src={imageSrc || "path/to/default-image.png"} 
            alt={`${gameName || "Unknown Game"} Background`} 
            className="card-image" 
          />
          
          <div className="overlay-gradient"></div>
          <div className="overlay-content">
            {score && <div className="game-score">{score}</div>}
            <div className="game-name">{gameName || "Unknown Game"}</div>
            {!score && (
              <div className="game-subtitle">{gameSubtitle || "Unknown Type"}</div>
            )}
          </div>
        </div>
      </div>
      <div className="game-day">
        {formatGameDateTime(gameDay, gameTime)}
      </div>
    </div>
  );
};
